import React, { useState, useEffect } from "react";
import { Music, Link as LinkIcon, X, Plus } from "lucide-react";

export default function AdminProjects() {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [data, setData] = useState([]);
  const [collection, setCollection] = useState([]);

  const [showCollectionFor, setShowCollectionFor] = useState(null);

  const [imagesToDelete, setImagesToDelete] = useState({
    image_2: false,
    image_3: false
  });

  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    desc_en: "",
    text:"",
    text_en:"",
    image: "",
    image_1: "",
    image_2: "",
    image_3: "",
    link: "",
    link_2: "",
    credits: ""
  });

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
  if (showForm) {
    fetchCollection();
  }
  }, [showForm]);

  const fetchProjects = async () => {
    const res = await fetch("/api/admin/projects/projects.php");
    const projects = await res.json();
    setData(projects);
  };

  const fetchCollection = async () => {
    const res = await fetch("/api/admin/assets/collection.php");
    const collection = await res.json();
    setCollection(collection);
  };

  async function handleSubmit(e) {
  e.preventDefault();

  const url = editingId
    ? "/api/admin/projects/edit_project.php"
    : "/api/admin/projects/add_project.php";

  const form = new FormData();

  form.append("title", formData.title);
  form.append("desc", formData.desc);
  form.append("desc_en", formData.desc_en);
  form.append("text", formData.text);
  form.append("text_en", formData.text_en);
  form.append("link", formData.link || "");
  form.append("link_2", formData.link_2 || "");
  form.append("credits", formData.credits || "");

  // 🔥 Gestion propre des images
  ["image", "image_1", "image_2", "image_3"].forEach(field => {
    if (formData[field] instanceof File) {
      form.append(field, formData[field]);
    } else if (typeof formData[field] === "string" && formData[field]) {
      form.append(field, formData[field]);
    }
  });

  if (imagesToDelete.image_2 && !(formData.image_2 instanceof File)) {
  form.append("delete_image_2", "1");
  }

  if (imagesToDelete.image_3 && !(formData.image_3 instanceof File)) {
    form.append("delete_image_3", "1");
  }

  if (editingId) {
    form.append("id", editingId);
  }

  try {
    const res = await fetch(url, {
      method: "POST",
      body: form
    });

    if (!res.ok) throw new Error("Erreur sauvegarde");

    fetchProjects();
    resetForm();

  } catch (err) {
    console.error(err);
    alert("Erreur upload");
  }
}

  function resetForm() {
    setShowForm(false);
    setEditingId(null);

    setImagesToDelete({
      image_2: false,
      image_3: false
    });

    setFormData({
      title: "",
      desc: "",
      desc_en: "",
      text: "",
      text_en: "",
      image: "",
      image_1: "",
      image_2: "",
      image_3: "",
      link: "",
      link_2: "",
      credits: ""
    });
  }

  function editProject(project) {
    setFormData({
      title: project?.title ?? "",
      desc: project?.desc ?? "",
      desc_en: project?.desc_en ?? "",
      text: project?.text ?? "",
      text_en: project?.text_en ?? "",
      image: project?.image ?? "",
      image_1: project?.image_1 ?? "",
      image_2: project?.image_2 ?? "",
      image_3: project?.image_3 ?? "",
      link: project?.link ?? "",
      link_2: project?.link_2 ?? "",
      credits: project?.credits ?? ""
    });

    setEditingId(project.id);
    setShowForm(true);
  }

  async function deleteProject(id) {
    if (!window.confirm("Supprimer ce projet ?")) return;

    try {
      await fetch("/api/admin/projects/delete_project.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });

      fetchProjects();
    } catch (err) {
      console.error("Erreur suppression projet", err);
    }
  }

  async function moveProject(id, direction) {
  await fetch("/api/admin/projects/move_project.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, direction })
  });

  fetchProjects();
}

  return (
      <section>
      <div>
                <div className="container-xl">
                  <div className="bg-white rounded shadow p-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h1 className="cat-title h3 fw-bold text-dark d-flex align-items-center gap-2">
                          <Music className="text-primary" />
                          Projets
                        </h1>
                        <p className="text-secondary mb-0">
                          Ajouter, modifier ou supprimer des projets
                        </p>
                        <button
                          onClick={() => {
                            setShowForm(!showForm);
                            if (showForm) {
                              setEditingId(null);
                              setFormData({
                                title: "",
                                desc: "",
                                desc_en: "",
                                text:"",
                                text_en:"",
                                image: "",
                                image_1: "",
                                image_2: "",
                                image_3: "",
                                link: "",
                                link_2: "",
                                credits: ""
                              });
                            }
                            setImagesToDelete({
                              image_2: false,
                              image_3: false
                            });
                          }}
                          className="btn btn-primary d-flex align-items-center gap-2 mt-2"
                        >
                          <Plus size={20} />
                          Ajouter
                        </button>
                      </div>
                    </div>
                  {showForm && (
                    <div className="bg-primary bg-opacity-10 p-4 rounded mt-4 w-100">
                      <h3 className="fw-semibold mb-3">
                        {editingId ? "Modifier le projet" : "Nouveau Projet"}
                      </h3>
      
                      <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                              <div className="col-12">
                                <label className="form-label fw-medium" htmlFor='title'>Titre</label>
                                <input className="form-control" type='text' value={formData.title} name='title' required onChange={(e)=> setFormData({...formData, title: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='desc'>Description [FR]</label>
                                <input className="form-control" type='text' value={formData.desc} name='desc' required onChange={(e)=> setFormData({...formData, desc: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='desc_en'>Description [EN]</label>
                                <input className="form-control" type='text' value={formData.desc_en} name='desc_en' required onChange={(e)=> setFormData({...formData, desc_en: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='text'>Texte [FR]</label>
                                <textarea className="form-control" type='text' rows='5' value={formData.text} name='text' required onChange={(e)=> setFormData({...formData, text: e.target.value})}>
                                </textarea>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='text_en'>Texte [EN]</label>
                                <textarea className="form-control" type='text' rows='5' value={formData.text_en} name='text_en' required onChange={(e)=> setFormData({...formData, text_en: e.target.value})}>
                                </textarea>
                              </div>
                              <div className="col-12">
                                <label className="form-label fw-medium" htmlFor='img'>Image Box</label>
                                <input
                                  className="form-control"
                                  type="file"
                                  accept="image/*"
                                  name="image"
                                  onChange={(e)=> setFormData({...formData, image: e.target.files[0]})}
                                />
                                <button
                                  type="button"
                                  className="btn
                                   btn-sm col-2 btn-outline-primary mt-2"
                                  onClick={() => setShowCollectionFor("image")}
                                >
                                  Collection
                                </button>

                                {/* Image existante */}
                                <div>
                                {typeof formData.image === "string" && formData.image && (
                                  <img
                                    src={formData.image}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}

                                {/* Nouvelle image */}
                                {formData.image instanceof File && (
                                  <img
                                    src={URL.createObjectURL(formData.image)}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}
                                </div>
                              </div>
                                  <div className="col-12 col-md-4">
                                <label className="form-label fw-medium" htmlFor='img_1'>Image 1</label>
                                <input
                                  className="form-control"
                                  type="file"
                                  accept="image/*"
                                  name="image_1"
                                  onChange={(e)=> setFormData({...formData, image_1: e.target.files[0]})}
                                />
                                <button
                                  type="button"
                                  className="btn
                                   btn-sm col-6 btn-outline-primary mt-2"
                                  onClick={() => setShowCollectionFor("image_1")}
                                >
                                  Collection
                                </button>

                                {/* Image existante */}
                                {typeof formData.image_1 === "string" && formData.image_1 && (
                                  <img
                                    src={formData.image_1}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}

                                {/* Nouvelle image */}
                                {formData.image_1 instanceof File && (
                                  <img
                                    src={URL.createObjectURL(formData.image_1)}
                                    alt="preview"
                                    style={{ width: "200px", marginTop: "10px" }}
                                  />
                                )}
                              </div>
                              <div className="col-12 col-md-4">
                                <label className="form-label fw-medium" htmlFor='img_2'>Image 2</label>
                                <input
                                  className="form-control"
                                  type="file"
                                  accept="image/*"
                                  name="image_2"
                                  onChange={(e)=> setFormData({...formData, image_2: e.target.files[0]})}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm col-6 btn-outline-primary mt-2"
                                  onClick={() => setShowCollectionFor("image_2")}
                                >
                                  Collection
                                </button>

                                {/* Image existante */}
                                {(typeof formData.image_2 === "string" && formData.image_2) ||
                                  formData.image_2 instanceof File ? (

                                    <div style={{ position: "relative", width: "200px", marginTop: "10px" }}>
                                      <img
                                        src={
                                          formData.image_2 instanceof File
                                            ? URL.createObjectURL(formData.image_2)
                                            : formData.image_2
                                        }
                                        alt="preview"
                                        style={{ width: "100%" }}
                                      />

                                      <button
                                        type="button"
                                        onClick={() => {
                                          setFormData({ ...formData, image_2: "" });
                                          setImagesToDelete({ ...imagesToDelete, image_2: true });
                                        }}
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          right: "5px",
                                          background: "black",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "28px",
                                          height: "28px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer"
                                        }}
                                      >
                                        <X size={14} />
                                      </button>
                                    </div>

                                  ) : null}
                              </div>
                              <div className="col-12 col-md-4">
                                <label className="form-label fw-medium" htmlFor='img_3'>Image 3</label>
                                <input
                                  className="form-control"
                                  type="file"
                                  accept="image/*"
                                  name="image_3"
                                  onChange={(e)=> setFormData({...formData, image_3: e.target.files[0]})}
                                />
                                <button
                                  type="button"
                                  className="btn col-6 btn-sm btn-outline-primary mt-2"
                                  onClick={() => 
                                    setShowCollectionFor("image_3")
                                  }
                                >
                                  Collection
                                </button>

                                {/* Image existante */}
                                {(typeof formData.image_3 === "string" && formData.image_3) ||
                                  formData.image_3 instanceof File ? (

                                    <div style={{ position: "relative", width: "200px", marginTop: "10px" }}>
                                      <img
                                        src={
                                          formData.image_3 instanceof File
                                            ? URL.createObjectURL(formData.image_3)
                                            : formData.image_3
                                        }
                                        alt="preview"
                                        style={{ width: "100%" }}
                                      />

                                      <button
                                        type="button"
                                        onClick={() => {
                                          setFormData({ ...formData, image_3: "" });
                                          setImagesToDelete({ ...imagesToDelete, image_3: true });
                                        }}
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          right: "5px",
                                          background: "black",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "28px",
                                          height: "28px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer"
                                        }}
                                      >
                                        <X size={14} />
                                      </button>
                                    </div>

                                  ) : null}
                              </div>
                              <div className="col-12">
                                <label className="form-label fw-medium" htmlFor='credits'>Credits photo</label>
                                <input className="form-control" type='text' value={formData.credits} name='credits' onChange={(e)=> setFormData({...formData, credits: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='link'>Lien video 1</label>
                                <input className="form-control" type='text' value={formData.link} name='link' onChange={(e)=> setFormData({...formData, link: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='link_2'>Lien video 2</label>
                                <input className="form-control" type='text' value={formData.link_2} name='link_2' onChange={(e)=> setFormData({...formData, link_2: e.target.value})}>
                                </input>
                              </div>
                            </div>
      
                            <div className="d-flex gap-2 mt-4">
                              <button type="submit" className="btn btn-primary">
                                {editingId ? "Modifier" : "Enregistrer"}
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setShowForm(false);
                                  setEditingId(null);
                                  setFormData({
                                    title: "",
                                    desc: "",
                                    desc_en: "",
                                    text:"",
                                    text_en:"",
                                    image: "",
                                    image_1: "",
                                    image_2: "",
                                    image_3: "",
                                    link: "",
                                    link_2: "",
                                    credits: ""
                                  });
                                  setShowCollectionFor(null);
                                }}
                                className="btn btn-secondary"
                              >
                                Annuler
                              </button>
                            </div>
                          </form>
                        </div>
                      )}
                      {showCollectionFor && (
                        <div className="mt-4 p-3 border rounded bg-light">
                          <h5>Sélectionner une image</h5>

                          <div className="row">
                            {collection.map((img) => (
                              <div className="col-3 mb-3" key={img.id}>
                                <img
                                  src={img.image}
                                  alt=""
                                  style={{ width: "100%", cursor: "pointer" }}
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      [showCollectionFor]: img.image
                                    });
                                    setImagesToDelete({
                                      ...imagesToDelete,
                                      [showCollectionFor]: false
                                    });
                                    setShowCollectionFor(null);
                                  }}
                                />
                              </div>
                            ))}
                          </div>

                          <button
                            type="button"
                            className="btn btn-secondary btn-sm mt-2"
                            onClick={() => setShowCollectionFor(null)}
                          >
                            Fermer
                          </button>
                        </div>
                      )}
                      <div className="row g-3 pt-4">
                        {data.map((project, i) => {
      
                          return (
                            <div className="col-md-4 mb-3" key={project.id}>
                              <div className="card border-dark bg-white rounded shadow p-3 h-100">
                                <div className="border-bottom pb-2 mb-2">
                                  <h2 className="h4 fw-bold">{project.title}</h2>
                                  <p className="text-muted small mb-0">{project.desc}</p>
                                  <img
                                    src={project.image}
                                    alt="preview"
                                    style={{ width: "100%", marginTop: "10px" }}
                                  />
                                </div>
                                          <div className="d-flex gap-1">
                                            <button
                                              onClick={() => editProject(project)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Modifier"
                                            >
                                              Modifier
                                            </button>
                                            <button
                                              onClick={() => deleteProject(project.id)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Supprimer"
                                            >
                                              <X size={18} />
                                            </button>
                                            <button
                                              onClick={() => moveProject(project.id, "up")}
                                              className="btn btn-sm btn-outline-dark"
                                            >
                                              ↑
                                            </button>

                                            <button
                                              onClick={() => moveProject(project.id, "down")}
                                              className="btn btn-sm btn-outline-dark"
                                            >
                                              ↓
                                            </button>
                                          </div>
                                  </div>
                            </div>
                          );
                        })}
                      </div>
                  </div>
                </div>
              </div>
    </section>
  );
}